import React, { ReactElement } from "react";
import ImageHolder from "./ImageHolder";
import { Button, Typography, Box } from "@mui/material";

type Props = {
    message: string;
    subMessage?: string[] | string;
    image: string;
    onButtonClick?: () => void;
    actionButtonLabel?: string;
};

const EmptyPage = (props: Props): ReactElement => {
    return (
        <Box
            height="100%"
            width="100%"
            display="flex"
            flexDirection="column"
            alignContent="center"       
            alignItems="center"
            pt={"10%"}
            data-testid="empty-state-page"
        >
            <ImageHolder maxHeight={200} maxWidth={150} src={props.image} />
            <Box mt={"24px"} display="flex" flexDirection="column" alignItems="center">
                <Typography fontWeight={"bold"} variant="body1" mb={2}>
                    {props.message}
                </Typography>
                {props.subMessage && typeof props.subMessage === "string" && (
                    <Typography variant="subtitle1">{props.subMessage}</Typography>
                )}
                {props.subMessage &&
                    typeof props.subMessage === "object" &&
                    props.subMessage.map(str => (
                        <Typography variant="subtitle1" key={str}>
                            {str}
                        </Typography>
                    ))}

                {props.actionButtonLabel && props.onButtonClick && (
                    <Box p={2}>
                        <Button
                            variant="text"
                            onClick={props.onButtonClick}
                            data-testid={`btn-${props.actionButtonLabel}`}
                        >
                            {props.actionButtonLabel}
                        </Button>
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default EmptyPage;
